import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@crono-one/design-system';
import { cn } from 'utils/style-utils';

interface IAttendeeRowProps {
  email: string;
  isOrganizer?: boolean;
  isSubscriptionUser?: boolean;
}

const AttendeeRow = ({
  email,
  isOrganizer,
  isSubscriptionUser,
}: IAttendeeRowProps) => (
  <div
    className={cn(
      'flex items-center gap-2 p-2 rounded-lg overflow-hidden shrink-0',
      !isSubscriptionUser ? 'bg-primary-200' : 'bg-neutral-100',
    )}
  >
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="text-xs text-neutral-800 truncate">{email}</span>
      </TooltipTrigger>

      <TooltipContent className="z-99999">{email}</TooltipContent>
    </Tooltip>

    {isOrganizer && (
      <Badge variant="white" tone="darkGray" size="sm">
        Organizer
      </Badge>
    )}
  </div>
);

export default AttendeeRow;
